import {
  Button,
  Grid,
  IconButton,
  Select,
  styled,
  Typography,
} from '@mui/material';

export const BackButton = styled(IconButton)(({ theme }) => ({
  margin: '-20px 0 -10px -30px',
  '& span': {
    fontSize: 40,
    color: theme.palette.secondary.main,
  },
}));

export const GridSection = styled(Grid)(({ theme }) => ({
  background: '#FFFFFE',
  boxShadow: '0px 3px 6px #00000029',
  borderRadius: 4,
  padding: '32px',
  [theme.breakpoints.down('xl')]: {
    padding: '24px',
  },
}));

export const GridItem = styled(Grid)(({ theme }) => ({
  display: 'flex',
  gap: 8,
  marginTop: '28px',
  [theme.breakpoints.down('xl')]: {
    marginTop: '20px',
  },
}));

export const GridItemX = styled(Grid)(({ theme }) => ({
  display: 'flex',
  gap: 8,
  marginTop: '28px',
  padding: '0 12px',
  [theme.breakpoints.down('xl')]: {
    marginTop: '20px',
  },
}));

export const LicenseTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.main,
  fontWeight: '600',
  height: '100%',
  display: 'flex',
  alignItems: 'flex-end',
  padding: '6px 0',
}));

export const LicenseButton = styled(Button)(() => ({
  width: '100%',
  mt: '8px',
  lineHeight: 1.2,
  '&:hover': {
    filter: 'brightness(85%)',
  },
}));

export const SectionTitle = styled(Typography)(() => ({
  fontSize: '21px',
  fontWeight: '600',
  color: '#707070',
}));

export const StyledInput = styled(Typography)(() => ({
  fontWeight: '500',
  fontSize: '16px',
  marginRight: 8,
}));

export const OutlinedButton = styled(Button)(({ theme }) => ({
  width: '100%',
  border: `2px solid ${theme.palette.secondary.main}`,
  borderRadius: '30px',
  color: theme.palette.secondary.main,
  fontWeight: '600',
  backgroundColor: '#FAFCFF',
  lineHeight: 1.2,
  gap: '8px',
}));

export const AddButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.primary.main,
  width: '50px',
  height: '50px',
  border: `1px solid ${theme.palette.primary.main}`,
  borderRadius: '12px',
  '& span': {
    fontWeight: '600',
  },
  '&:hover': {
    backgroundColor: theme.palette.primary.main,
    color: 'white',
  },
  '&:disabled': {
    color: '#A9A9A9',
    border: '1px solid #A9A9A9',
  },
}));

export const StyledSelect = styled(Select, {
  shouldForwardProp: (prop) => prop !== 'hasValue',
})<{ hasValue: boolean }>(({ hasValue }) => ({
  borderRadius: '16px',
  '& .MuiSelect-select': {
    padding: '14px 24px 14px 14px',
  },
  '.MuiOutlinedInput-notchedOutline legend': {
    width: hasValue ? undefined : 0,
  },
}));
